(function () {
	'use strict';
	angular.module('app.supplyChain')
		.controller('prInsideLeadTime', prInsideLeadTime);

	prInsideLeadTime.$inject = ['$location'];

	function prInsideLeadTime($location) {
		// redirect to new path
		$location.path('/supply-chain/purchase-requisitions/').replace();
	}
})();
